function checkVariantAvailability() {
  var oosForm = document.getElementById('esc-oos-form');
  var variantSelection = document.querySelector('variant-selection');
  
  if (!variantSelection) {
    return;
  }
  
  // check if any selected option is unavailable
  var selectedOptions = document.querySelectorAll('[data-variant-option-value]:checked');
  var hasUnavailableOption = false;
  
  selectedOptions.forEach(function(option) {
    var isAvailable = option.getAttribute('data-variant-option-available') === 'true';
    var isAccessible = option.getAttribute('data-variant-option-accessible') === 'true';
    
    if (!isAvailable || !isAccessible) {
      hasUnavailableOption = true;
    }
  });
  
  // also check the current variant id from Empire's data
  var currentVariantId = variantSelection.getAttribute('variant');
  if (currentVariantId) {
    var hiddenSelect = document.querySelector('select[data-variants] option[value="' + currentVariantId + '"]');
    if (hiddenSelect && hiddenSelect.disabled) {
      hasUnavailableOption = true;
    }
  }
  
  // show/hide form based on availability
  if (hasUnavailableOption) {
    oosForm.style.display = 'block';
  } else {
    oosForm.style.display = 'none';
  }
}

setTimeout(function() {
  // check if we're on a product page with variants
  var variantSelection = document.querySelector('variant-selection');
  if (!variantSelection) {
    return;
  }
  
  // check initial state
  checkVariantAvailability();
  
  // listen for changes on ALL variant option inputs
  var variantInputs = document.querySelectorAll('[data-variant-option-value]');
  variantInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      setTimeout(checkVariantAvailability, 100);
    });
  });
  
  // listen for clicks on swatch wrappers (backup method)
  var swatchWrappers = document.querySelectorAll('[data-variant-option-value-wrapper]');
  swatchWrappers.forEach(function(wrapper) {
    wrapper.addEventListener('click', function() {
      setTimeout(checkVariantAvailability, 150);
    });
  });
  
  // listen for changes on the hidden select
  var hiddenSelect = document.querySelector('select[data-variants]');
  if (hiddenSelect) {
    hiddenSelect.addEventListener('change', function() {
      setTimeout(checkVariantAvailability, 50);
    });
  }
  
  // listen for attribute changes on the variant-selection element
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'variant') {
          setTimeout(checkVariantAvailability, 100);
        }
      });
    });
    
    observer.observe(variantSelection, { attributes: true });
  }
}, 1000);